import { render, staticRenderFns } from "./ResetTrial.vue?vue&type=template&id=1d35893a&scoped=true&"
import script from "./ResetTrial.vue?vue&type=script&lang=js&"
export * from "./ResetTrial.vue?vue&type=script&lang=js&"
import style0 from "./ResetTrial.vue?vue&type=style&index=0&id=1d35893a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d35893a",
  null
  
)

export default component.exports